// extracted by mini-css-extract-plugin
export default {"active":"button-switch_active__I8A9j","button-group":"button-switch_button-group__skica","mobile-hide":"button-switch_mobile-hide__S+XZc"};